export function vendorInfoFactory($resource, MyConstant) {
    "ngInject"

    return $resource('', {}, {
        shippment: {
            url: `${MyConstant.ApiUrl}ECBTempGeneral/GetVendorTransportTypes?productID=:productId&vendorID=:vendorId`,
            isArray: true
        },
        payment: {
            url: `${MyConstant.ApiUrl}ECBTempGeneral/GetVendorPaymentTypes?vendorID=:vendorId`,
            isArray: true
        },
        warranty: {
            url: `${MyConstant.ApiUrl}ECBTempGeneral/GetVendorWarrantyTypes?productID=:productId&vendorID=:vendorId`,
            isArray: true
        },
        checkState:{
            url:`${MyConstant.ApiUrl}Auth/CheckVendorState`
        },
        get: {
            url: `${MyConstant.ApiUrl}ECBVendorAbstractInfo/GetVendorInfo?vendorID=:vendorId`,
        }
    })
} 


// WEBPACK FOOTER //
// ./src/factories/vendor-info/vendor-info.ts